export enum WalletBarcodeType {
    Undefined = 0,
    QRCode = 1,
    PDF417 = 2,
    Aztec = 3,
    Code128 = 4
}
